<template lang="pug">
  .main-container
    .tabs-content-wrapper
      aiq-tabs(
        v-model="activeTab"
        @tab-click="onTabChange"
        type="border-card"
      )
        aiq-tab-pane(
          label="Export"
          name="IQTools.Migrate.Export"
        )
          router-view(v-if="activeTab === 'IQTools.Migrate.Export'")
        aiq-tab-pane(
          label="Import",
          name="IQTools.Migrate.Import"
        )
          router-view(v-if="activeTab === 'IQTools.Migrate.Import'")
</template>

<script>
import { buildingKitAiTesting } from '../Partials';

export default {
  name: 'MigrateTabsLayout',
  components: { buildingKitAiTesting },
  data() {
    return {
      activeTab: this.$route.name,
    };
  },
  watch: {
    $route(to) {
      this.activeTab = to.name;
    },
  },
  methods: {
    onTabChange(tab) {
      this.$router.push({ name: tab.paneName || tab.name });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tabs-content-wrapper {
  flex: 1;
  min-height: 0;

  :deep(.el-tabs) {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  :deep(.el-tabs__header) {
    flex-shrink: 0;
  }

  :deep(.el-tabs__content) {
    flex: 1;
    min-height: 0;
  }

  :deep(.el-tab-pane) {
    height: 100%;
  }
}
</style>
